import HeatingHours from './pages/components/HeatingHours'
import DailyReportDashBoard from './pages/dailyReport/DailyReportDashBoard'
import Dashboard from './pages/Dashboard'
import dispatches from './pages/dispatches/Dispatches'
import InventoryDashboard from './pages/InventoryDashboard'
import OrderProcessFunnel from './pages/OrderProcessFunnel'
import ProfitAnalytics from './pages/profitAnalytics/ProfitAnalytics'
import ProfitAnalyticsDetail from './pages/profitAnalytics/ProfitAnalyticsDetail'
import Reports from './pages/report/Report'

export const ROUTES = [
  {
    component: Dashboard,
    isPublic: true,
    path: '/analytics',
    slug: 'Analytics',
    title: 'Analytics',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: InventoryDashboard,
    isPublic: true,
    path: '/analytics/inventory',
    slug: 'InventoryAnalytics',
    title: 'Inventory Analytics',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Reports,
    isPublic: true,
    path: '/analytics/summary',
    slug: 'reports',
    title: 'reports',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: dispatches,
    isPublic: true,
    path: '/analytics/dispatches',
    slug: 'dispatches',
    title: 'Dispatches',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: DailyReportDashBoard,
    isPublic: true,
    path: '/analytics/daily-report',
    slug: 'dailyReports',
    title: 'Daily Reports',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: OrderProcessFunnel,
    isPublic: true,
    path: '/analytics/order-process-funnel',
    slug: 'OrderProcessFunnel',
    title: 'OrderProcessFunnel',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: HeatingHours,
    isPublic: true,
    path: '/analytics/heat-map',
    slug: 'HeatMap',
    title: 'HeatMap',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ProfitAnalytics,
    isPublic: false,
    path: '/analytics/profit-analytics',
    slug: 'ProfitAnalyticsEngine',
    title: 'Profit Analytics Engine',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ProfitAnalyticsDetail,
    isPublic: false,
    path: '/analytics/profit-analytics/:id',
    slug: 'ProfitAnalyticsEngineDetail',
    title: 'Profit Report Detail',
    isProtected: true,
    showMenu: false,
    redirectTo: '/auth/login',
    isExact: true,
  },
]
